import { useMemo } from "react";
import { TICKET_STAGES, TICKET_STATUSES } from "./ticketConstants";

const SUMMARY_KEYS = [...TICKET_STATUSES, ...TICKET_STAGES];

export default function TicketStatusSummary({ tickets }) {
  const statusCounts = useMemo(() => {
    const counts = {};
    SUMMARY_KEYS.forEach((s) => (counts[s] = 0));

    tickets.forEach((t) => {
      if (counts[t.status] !== undefined) {
        counts[t.status] += 1;
      }

      if (counts[t.processingStage] !== undefined) {
        counts[t.processingStage] += 1;
      }
    });

    return counts;
  }, [tickets]);

  return (
    <ul className="ticket-status-summary" aria-label="Ticket counts">
      {SUMMARY_KEYS.map((status) => (
        <li key={status} className={`status-block ${status}`}>
          <span className="status-label">{status}:</span>
          <span className="status-count">{statusCounts[status]}</span>
        </li>
      ))}
    </ul>
  );
}
